import { render } from "./TwilioFirstColView.vue?vue&type=template&id=ff81cb52&scoped=true"
import script from "./TwilioFirstColView.vue?vue&type=script&lang=js"
export * from "./TwilioFirstColView.vue?vue&type=script&lang=js"

import "./TwilioFirstColView.vue?vue&type=style&index=0&id=ff81cb52&scoped=true&lang=css"

import exportComponent from "/vercel/path0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ff81cb52"]])

export default __exports__